import { Outlet } from 'react-router-dom';

export const EventMonitoringOutlet = () => <Outlet />;
